<template>
	<div class='hotgoods-wrapper'>
		<div class='title-wrapper'>
			<img style="width: 75%" class="menu-item-icon" src="../../../assets/image/home/goferBro.svg" />
		</div>
		<div class='goods-list' style="margin-left: -20px; padding-left: 20px">
			<ul>
				<li
					v-for="(item, index) in stores"
					v-bind:key="index">
					<div class='img'>
						<img :src="item.store_picture" v-on:click='goStoreDetail(item.store_id)'>
					</div>
					<div class="item-title">{{ item.store_name }}</div>
					<div style="font-size: 0.5rem; color: #6C6C6C; font-weight: bold;">{{ item.storeclass_name }}</div>
				</li>
				<div style="width: 10px; height: 149px">
					<span style="visibility: hidden;">ab</span>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'IndexHotStores',
	data () {
		return {
		}
	},
	props: ['items'],
	components: {

	},
	computed: {
		stores() {
			return this.items.filter(item => item.store_recommend == 1)
		}
	},
	methods: {
		goStoreDetail (store_id) {
			this.$router.push({ name: 'HomeStoredetail', query: { 'id': store_id } })
		},
		productClick: function () {
			this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.item.goods_id } })
		}
	}
}
</script>

<style lang="scss" scoped>
.hotgoods-wrapper{
	padding: 0 0.4rem;
	background: #f4c41e;
	width: 88%;
	position: relative;
	z-index: 3;
	border-radius: 10px;
	margin-bottom: 4rem;
	margin-left: 10px;
	margin-top: 13rem;
	height: 172px;
	box-shadow: 3px 6px 7px 0px #7b7b7b;
}
.hotgoods-wrapper .title-wrapper{
	display: flex;
	align-items: center;
	padding: .5rem 0 0;
	// justify-content: flex-start;
}
.hotgoods-wrapper .title-wrapper .title{font-size: .9rem;color: #333;font-weight: bold;margin-right: .5rem;}
.hotgoods-wrapper .title-wrapper .icon{display: flex;font-size: .7rem;background: #FFAD10;border-radius: 1rem;padding: .1rem;}
.hotgoods-wrapper .title-wrapper .icon .left{color: #fff;padding: .2rem .7rem;}
.hotgoods-wrapper .title-wrapper .icon .right{color: #FFAD10;background: #fff;padding: .2rem .7rem;border-radius: 0 1rem 1rem 0;}
.hotgoods-wrapper .goods-list{
	margin-top: .5rem;
	height: 200px;
	width: 108%;
	overflow-x: scroll;
	overflow-y: hidden;
}
.hotgoods-wrapper .goods-list::-webkit-scrollbar {
	display: none;
}
.hotgoods-wrapper .goods-list ul{
	display: flex;
	// flex-wrap: wrap;
	justify-content: flex-start;
}
.hotgoods-wrapper .goods-list ul li{
	// width: 49%;
	margin-bottom: .25rem;
	height: 149px;
	width: 124px;
	margin-left: 10px;
}
.hotgoods-wrapper .goods-list ul li:first-child {
	margin-left: 0;
}
// .hotgoods-wrapper .goods-list ul li:nth-child(3n){
// 	margin-right: 0;
// }
.hotgoods-wrapper .goods-list ul li .img{
	// width: 100%;
	border-radius: .5rem;
	overflow: hidden;
	height: 149px;
	width: 124px;
	box-shadow: 3px 3px 6px 0px #7b7b7b;
}
.hotgoods-wrapper .goods-list ul li .img img{width: 100%;height: 100%;}
.hotgoods-wrapper .goods-list ul li .item-title{
	// color: $formInputColor;
	// font-size: $fontSize;
	// padding:.3rem 0;
	// text-align: center;
	padding: 0.5rem 0 0.3rem;
	text-align: revert;
	font-weight: bold;
	color: #6C6C6C;
	font-size: 0.75rem;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
</style>
